import type { IdMap } from '@api/org';

export const flattenIdMap = <T = Record<string, string>>(
    { idKey, valueKey }: { idKey: string; valueKey: string },
    idMap: IdMap
): T[] => {
    return Object.entries(idMap).map(([key, value]) => ({
        [idKey]: key,
        [valueKey]: value,
    })) as T[];
};
